import { platform } from '@/utils/browser'
import { getUserDetail } from '@/service'

export default {
    namespaced: 'user',
    state: {
        userDetail: {
            nickname: '',
            username: '',
            mobile: '',
            reg_time: null,
            game_id: null,
            ip: null,
            user_id: null,
            identity_card: '',
            platform,
            referer: '',
            sex: 0,
        },
    },
    actions: {
        getUserDetail({ commit }, data = {}) {
            getUserDetail(data).then(res => {
                if (Number(res.code) === 0) {
                    commit('UPDATE_USER_DETAIL', res.data)
                }
            })
        },
    },
    mutations: {
        UPDATE_USER_DETAIL(state, detail) {
            state.userDetail = { ...detail }
        },
    },
}
